import { render, staticRenderFns } from "./MarketingSegments.vue?vue&type=template&id=4b260f90&"
import script from "./MarketingSegments.vue?vue&type=script&lang=js&"
export * from "./MarketingSegments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports